import React from 'react';

const ModalContentPostcodeRisk = React.createClass({

    propTypes: {
        exclusions: React.PropTypes.string
    },

    render() {
        return (
            <div>
                <p>Due to the location of this property, {this.props.exclusions} cover will be excluded from your policy.</p>

                <p>If you wish to discuss this exclusion or want to find out more about how this would impact your policy, please call our Insurance team on 0800 038 4574.</p>

                <p>We&rsquo;re open:</p>
                <ul>
                    <li>Weekdays: 8:30am - 5:30pm</li>
                    <li>Saturday: 9:30am - 1:00pm</li>
                </ul>
            </div>
        );
    }


});

export default ModalContentPostcodeRisk;


/** WEBPACK FOOTER **
 ** ./src/components/Modals/Content/ModalContentPostcodeRisk.js
 **/